import { AxiosResponseHeaders } from 'axios';
import { DealerRateExecuteResponseDTO } from '../entities';

const dealerRateExecuteDTOToDealerRateExecuteAdapter = (
  data: DealerRateExecuteResponseDTO,
  headers?: AxiosResponseHeaders,
) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { dealerRateExecuteDTOToDealerRateExecuteAdapter };
